import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';

import { ConfigService } from '../config/config.service';
import { ProductCategory } from './product-category';
import { LoggingService } from '../loging/logging.service';
export class ProductCategoriesService {
    title = 'Product Categories Service';
private productCategoriesUrl = '';
private productCategoriesImagesUrl = '';
private config: any;
private headers = new Headers({ 'Content-Type': 'application/json' });
/**
 * @param {?} http
 * @param {?} configService
 * @param {?} loggingService
 */
constructor(
private http: Http,
private configService: ConfigService,
private loggingService: LoggingService
    ) {
        this.configService.getConfig((configuration: any) => {
            this.config = configuration;
            this.productCategoriesUrl = this.config.baseUrl + '/product-categories';
            this.productCategoriesImagesUrl = this.config.baseUrl + '/product-categories/images';
        });
    }
/**
 * @param {?} error
 * @return {?}
 */
private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
/**
 * @return {?}
 */
getProductCategories(): Observable<ProductCategory[]> {

        return this.http.get(this.productCategoriesUrl).map(res => res.json());
    }
/**
 * @param {?} productCategory
 * @return {?}
 */
addProductCategory(productCategory: ProductCategory): Observable<ProductCategory> {

        return this.http.post(
            this.productCategoriesUrl,
            JSON.stringify({ productCategory: productCategory }),
            {
                headers: this.headers
            }
        )
            .map(res => res.json())
            .map(obj => ({ _id: obj._id, Key: obj.Key, DisplayIndex: obj.DisplayIndex, ImageUrl: obj.ImageUrl }))
    }
/**
 * @param {?} productCategoryName
 * @return {?}
 */
deleteProductCategory(productCategoryName: string): Observable<any> {
        const /** @type {?} */ url = `${this.productCategoriesUrl}/${productCategoryName}`;
        return this.http.delete(url).map(res => res.json()).catch(this.handleError);
    };
/**
 * @param {?} productCategory
 * @param {?} displayIndex
 * @return {?}
 */
moveProductCategoryTo(productCategory: string, displayIndex: number): Observable<ProductCategory[]> {
        const /** @type {?} */ url = this.productCategoriesUrl + '/' + productCategory + '/move-to/' + displayIndex;
        return this.http.put(url, null).map(res => res.json());
    }
/**
 * @param {?} productCategory
 * @param {?} fileName
 * @param {?} fileType
 * @param {?} file
 * @return {?}
 */
getImageSignature(productCategory: ProductCategory, fileName: string, fileType: string, file: any): Observable<any> {
        const /** @type {?} */ url = this.productCategoriesImagesUrl + '/sign?file_name=' + fileName + '&file_type=' + fileType + '&product_category=' + productCategory.Key;
        this.loggingService.log('getImageSignature: productCategory = ');
        this.loggingService.log(productCategory);
        let /** @type {?} */ observableOfFile = Observable.of(file);

        return observableOfFile.mergeMap((file) => {
            return this.http.get(url).map(res => res.json())
                .map((res) => {
                    return { response: res, File: file, ProductCategory: productCategory };
                });
        });
    }
/**
 * @param {?} file
 * @param {?} signed_request
 * @param {?} url
 * @param {?} productCategory
 * @return {?}
 */
uploadImage(file: any, signed_request: string, url: string, productCategory: ProductCategory): Observable<any> {

        return Observable.create((observer: any) => {
            let /** @type {?} */ xhr = new XMLHttpRequest();
            xhr.open("PUT", signed_request);
            xhr.setRequestHeader('x-amz-acl', 'public-read');

            xhr.onload = () => {
                if (xhr.status === 200) {
                    // done(url, this);
                    observer.next({ImageUrl: url, ProductCategory: productCategory});
                    observer.complete();
                } else if (xhr.status === 403) {
                    // this.delete(file, signed_request, url, done);
                    observer.error('403 error');
                } else {
                    observer.error(xhr.response);
                }
            }

            xhr.send(file);
        });
    }
/**
 * @param {?} productCategory
 * @param {?} imageUrl
 * @return {?}
 */
updateProductCategoryImageUrl(productCategory: ProductCategory, imageUrl: string){
        const /** @type {?} */ url = `${this.productCategoriesUrl}/${productCategory}`;
        productCategory.ImageUrl = imageUrl;
        
                return this.http.put(
                    url,
                    JSON.stringify(productCategory),
                    {
                        headers: this.headers
                    }
                ).map(res => res.json());
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ConfigService, },
{type: LoggingService, },
];
}

function ProductCategoriesService_tsickle_Closure_declarations() {
/** @type {?} */
ProductCategoriesService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductCategoriesService.ctorParameters;
/** @type {?} */
ProductCategoriesService.prototype.title;
/** @type {?} */
ProductCategoriesService.prototype.productCategoriesUrl;
/** @type {?} */
ProductCategoriesService.prototype.productCategoriesImagesUrl;
/** @type {?} */
ProductCategoriesService.prototype.config;
/** @type {?} */
ProductCategoriesService.prototype.headers;
/** @type {?} */
ProductCategoriesService.prototype.http;
/** @type {?} */
ProductCategoriesService.prototype.configService;
/** @type {?} */
ProductCategoriesService.prototype.loggingService;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
